var module = angular.module('octopusApp.master');

module.directive('gettingStartedDetail', function () {
    return {
        templateUrl: 'areas/master/getting-started/views/getting_started_detail.html',
        restrict: 'E',
        replace: true,
        scope: {
            isLoading: '=loading'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: function ($scope, $q, busy, gettingStartedStatusFactory, octopusRepository) {
            var vm = this;
            var isLoading = vm.isLoading || busy.create();

            vm.imageOctopus = require('../../../../img/getting-started/Octopus.svg');
            vm.imageEnvironments = require('../../../../img/getting-started/Environments.svg');
            vm.imagePackage = require('../../../../img/getting-started/Package.svg');
            vm.imageProject = require('../../../../img/getting-started/Project.svg');
            vm.imageDeploy = require('../../../../img/getting-started/Deploy.svg');

            vm.isSetup = false;

            function refresh(tasksStatus) {
                vm.tasks = tasksStatus.tasks;
                vm.next = tasksStatus.next;
                vm.projects = tasksStatus.projects;
                vm.releases = tasksStatus.releases;
            }

            isLoading.promise(gettingStartedStatusFactory.promise).then(function(tasksStatus){
                if (tasksStatus.tasks.Deploy.DeployedRelease.IsComplete) {
                    vm.isSetup = true;
                    return;
                }

                gettingStartedStatusFactory.subscribe($scope, refresh);
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/directives/getting_started_detail.js
// module id = 2859896431231939
// module chunks = 1